var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-gpt"},[_c('GptMenu',{ref:"gptMenu",on:{"change":_vm.changeMenu}}),_c('ChatWin',{attrs:{"info":_vm.info},on:{"renovateMenu":_vm.renovateMenu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }